import React, { useEffect, useState } from "react";
import PageHeader from "../../components/PageHeader";
import PayoutViewComponent from "../../components/Payout/PayoutView";
import { useParams } from "react-router-dom";
import { viewPayoutAction } from "../../actions";
import { connect } from 'react-redux';

function PayoutView({ viewPayoutAction }) {
    const params = useParams();
    const id = params.id;
    const [payout, setPayoutData] = useState(null);


    useEffect(() => {
        window.scrollTo(0, 0);
    });

    useEffect(() => {
        if (id) {
            viewPayoutAction({ id: id }, (err, response) => {
                if (!err) {
                    setPayoutData(response.data.data);
                }
            });
        }
    }, [id]);

    return (
        <div
            style={{ flex: 1 }}
            onClick={() => {
                document.body.classList.remove("offcanvas-active");
            }}
        >
            <div>
                <div className="container-fluid">
                    {payout && <PageHeader
                        HeaderText="Payout Detail"
                        Breadcrumb={[
                            { name: "Payouts", navigate: "/payouts" },
                            { name: "Payout Detail", navigate: `` },
                        ]}
                    />}
                    <div className="row clearfix">
                        <PayoutViewComponent payout={payout} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(null, { viewPayoutAction })(PayoutView)
